var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlaybtn = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 80 80",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40 0c22.091 0 40 17.909 40 40S62.091 80 40 80 0 62.091 0 40 17.909 0 40 0Zm-8.359 25.158a1.25 1.25 0 0 0-.641 1.09v27.5a1.25 1.25 0 0 0 1.906 1.063l22.485-13.75a1.234 1.234 0 0 0 0-2.125l-22.485-13.75a1.25 1.25 0 0 0-1.265-.028Z",
  fill: "#FFF",
  fillRule: "evenodd"
})));
export default SvgPlaybtn;